<div
    class="badge fx-row fx-layout-align-start-center fx-layout-gap-8"
    [class.header]="headerStyle"
    [dialogLink]="headerStyle ? undefined : ['alert', alert?.id]"
>
    <!-- session icon -->
    <mat-icon [svgIcon]="iconToUse.svgIcon" [class]="iconToUse.class"></mat-icon>

    <!-- ev and date info -->
    <div class="info fx-column fx-flex" [matTooltip]="alert?.title">
        <label>{{ alert?.title }}</label>
        <ng-container *ngIf="displayStation">
            <div class="fx-row">
                <span class="station fx-flex">{{ alert?.stationName }}</span>
                <span class="date">{{ alert?.timestamp | csmsDuration: { ago: true } }}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="!displayStation">
            <span class="date">{{
                alert?.timestamp
                    | adjustUtcDate
                        : { format: 'DD.MM.yyyy HH:mm', time: (currentTime$ | async), showUtcTimeLabel: true }
            }}</span>
        </ng-container>
    </div>
</div>
